import { getCurrentUser } from '@creditsights/api-ui-web';
import useLocalStorage from './useLocalStorage';

const useUserLocalStorage = <T>(
  key: string,
  initialValue: T
): readonly [T, (newVal: T | ((prevVal: T) => T)) => void] => {
  const { userId } = getCurrentUser();
  return useLocalStorage(`${key}_${userId}`, initialValue);
};

export default useUserLocalStorage;
